<template>

<div class="genreBoard">
    <div v-on:click="moveToteennovel" v-bind:class="{'genreBtnActive': genreActive[0].isActive}"  class="genreBtn linkable" >청소년 소설</div>
    <div v-on:click="moveToscifi" v-bind:class="{'genreBtnActive': genreActive[1].isActive}" class="genreBtn linkable">과학 소설</div>
    <div v-on:click="moveTofantasy" v-bind:class="{'genreBtnActive':genreActive[2].isActive}" class="genreBtn linkable" >환상 소설</div>
    <div class="genreBtn genreBtnSleep">추리 소설</div>
    <!--   
    -->
    <div v-on:click="moveTosocialwelfare" v-bind:class="{'genreBtnActive': genreActive[4].isActive}" class="genreBtn linkable"> 논픽션 </div> 
</div>
  
</template>


<script>

export default {

  props: ['genreActive'],


  methods: {

        moveToteennovel: function() {

          this.$emit('moveToteennovel');
          console.log("청소년문학 활동", this.genreActive[0].isActive);
          console.log("사회복지 활동", this.genreActive[1].isActive);
          
        },

      moveTosocialwelfare: function() {

          this.$emit('moveTosocialwelfare');

          console.log("청소년문학 활동", this.genreActive[0].isActive);
          console.log("사회복지 활동", this.genreActive[1].isActive);         

        },

      moveToscifi: function() {

        this.$emit('moveToscifi');
        

      },

      moveTofantasy: function() {

        this.$emit('moveTofantasy');

      }

    }

}

</script>



<style scoped>

.genreBoard {

  box-sizing: border-box;
  
  display: flex;
  justify-content: space-around;
  
  padding-left: 190px;
  padding-right: 190px;

  text-align: center;
   
}

.linkable {

  cursor: pointer;

}

.genreBtn {

  box-sizing: border-box;

  display:inline-flex;
  justify-content: center;

  
  
  width: 120px;
  height: 60px;
  
  padding-top: 5px;
  padding-bottom: 10px;
  border-radius: 5px;

  font-size: 18px;
   
}

.genreBtnSleep {

  color:gray;
  opacity:0.6;

  height: 40px;

}
.genreBtnActive {
  
  background-color: #f1f1f1;

  height: 40px;


}

</style>
